export const CAMERA_HEIGHT = 1.4;
export const SHADOW_OFFSET = 0.1;
